export default __webpack_public_path__ + "static/media/flags@2x.140042eb.png";